import { ReactNode } from "react";

interface AppShellProps {
  children: ReactNode;
}

// Header/Footer/WhatsApp now live in the persistent RootLayout
// so the marquee + other mount-state survive route changes.
// AppShell remains as a per-page wrapper for backward compatibility.
export function AppShell({ children }: AppShellProps) {
  return <>{children}</>;
}
